import { useState, useEffect, useContext } from 'react';
import styles from '../../../../index.module.less';
import {clueFollowLogList, clueFollowLogAdd} from '@/services/callCenter'
import {Form, Spin, Input, message, Button, Empty, Select} from 'antd';
import dayjs from 'dayjs';
import {trimStr} from "@/utils/data.ts";
import {getEnums} from "@/services/homeService.ts";
import clueDetailContext from "@/pages/callTool/intelligentOutboundCall/components/Info/clueDetailContext.ts";
const { TextArea } = Input;

function FollowUpDiary(props: any) {
  const {detailInfo, isFreePhone} = useContext(clueDetailContext)
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [refresh, setRefresh] = useState(false); // 列表刷新
  const [followRecordList, setFollowRecordList] = useState([])
  const [followTypeList, setFollowTypeList] = useState([])
  useEffect(() => {
    getFollowUpRecord();
  }, [detailInfo, refresh]);

  useEffect(() => {
    getFollowTypeList()
    form.setFieldValue('followType', 'trackPhone')
  }, []);

  // 获取跟进记录数据
  const getFollowUpRecord = () => {
    if (!detailInfo.id || loading) return;
    setLoading(true);
    clueFollowLogList({orderBys:[{columnName: 'ID', asc: false}], clueId: detailInfo.id })
      .then((res: any) => {
        setFollowRecordList(res||[])
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getFollowTypeList = () => {
    getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.AddRecordTypeEnum').then(res => {
      setFollowTypeList(res)
    })
  }

  // 提交保存跟进记录
  const onFinish = (values: any) => {
    if (!detailInfo.id) return;
    setSubmitLoading(true);
    clueFollowLogAdd({
      ...values,
      clueId: detailInfo.id,
    })
      .then((res: any) => {
        message.success(res.message || '操作成功');
        form.resetFields();
        form.setFieldValue('followType', 'trackPhone')
        setRefresh(!refresh);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };
  const listItme = (data: any, index: any) => {
    return (
      <div className={styles.followListItem} key={index}>
        <div className={styles.itemHead}>
          <div className={styles.itemHeadTitle}>
            {data['buttonName']} - <span style={{ fontSize: 12 }}>{data?.createdTime?dayjs(data.createdTime).format('YYYY-MM-DD HH:mm:ss'):''}</span>
          </div>
          <div className={styles.itemHeadTxt}>类型：{data['followerTypeName']}</div>
        </div>
        <div className={styles.itemMain}>
          <div className={styles.itemRow}>
            <div className={styles.itemRowContent}>{data.followerType === 'VIEW_PHONE' ? `【${data.name}】` : ''} {data['content']}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.followUpDiary}>
          <Spin spinning={loading || submitLoading}>
      <div>
        <div className={styles.followContent}>
          <Form onFinish={onFinish} form={form} layout={'vertical'}>
            <Form.Item label="跟进方式" name="followType" rules={[{ required: true, message: '不能为空' }]}>
              <Select disabled={isFreePhone} placeholder="请选择跟进方式" allowClear options={followTypeList} fieldNames={{label: 'description', value: 'key'}}/>
            </Form.Item>
            <Form.Item label="跟进内容" name="content" rules={[{ required: true, message: '不能为空' }]}>
              <TextArea disabled={isFreePhone} placeholder="请填写跟进内容" allowClear
                        maxLength={400} showCount
                        onChange={(e) => form.setFieldValue('content', trimStr(e.target.value))}/>
            </Form.Item>
            <Form.Item className={styles.followSaveBtn}>
              <Button type="primary" loading={submitLoading} disabled={!detailInfo.id || submitLoading || isFreePhone} htmlType="submit">
                保存
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className={styles.followList}>
          <div className={styles.followTitle}>跟进记录</div>
            {followRecordList.length ? (
              followRecordList.map((d: any, i: any) => listItme(d, i))
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
            )}
        </div>
      </div>
          </Spin>
    </div>
  );
}

export default FollowUpDiary;
